import { render, staticRenderFns } from "./Messager.vue?vue&type=template&id=224a63ec&scoped=true"
import script from "./Messager.vue?vue&type=script&lang=js"
export * from "./Messager.vue?vue&type=script&lang=js"
import style0 from "./Messager.vue?vue&type=style&index=0&id=224a63ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224a63ec",
  null
  
)

export default component.exports